
import React, { useState, useEffect, useMemo } from 'react';
import Draggable from 'react-draggable';
import {
    withStyles,
    DialogTitle,
    DialogContent,
    Dialog,
    Paper,
    Tooltip,
    TextField,
    IconButton,
    Button,
    Typography
} from '@material-ui/core/';

import InfoOutlined from '@material-ui/icons/InfoOutlined';

import {
    loadText,
    saveText
} from '@apricityhealth/web-common-lib/utils/Services';

function EditableNote({ appContext, textId, planId, language, classes }) {
    //console.log("EditableNote:", { appContext, textId, planId, language, classes });

    if (!language) language = "en-us"
    const [text, setText] = useState([]);
    const [modified, setModified] = useState(false);
    const [editText, setEditText] = useState(false)

    const hierarchy = useMemo(() => {
        const { plans } = appContext.state;
        const hierarchy = [];

        // find the root plan firstly..
        const root = plans && plans.find((e) => e.planId === planId);
        if ( root ) {
            const queue = [ root ];
            while (queue.length > 0 ) {
                const plan = queue.shift();
                hierarchy.push( plan );

                for(let i=0;i<plan.dependencies.length;++i) {
                    const child = plans.find((e) => e.planId === plan.dependencies[i]);
                    if ( child && !hierarchy.find((e) => e.planId === child.planId )) {
                        queue.push( child );
                    }
                }
            }
        }

        console.log("hierarchy:", hierarchy );
        return hierarchy;
    }, [appContext, planId ]);

    // Auto fetch the data on mount
    useEffect(() => {
        async function load() {
            try {
                setText( await loadText(appContext, { textId, language, dependencies: true, resolveConflicts: false, planId }) );
            } catch(err) {
                console.error("EditableNote error:", err );
            }
        }
        load();

        return () => {
            setText([]);
        }
    }, [textId, planId, language])

    function onClose() {
        setEditText(false);
        if (text && modified) {
            saveText(appContext, text).catch((err) => {
                console.error("EditableNote error:", err );
            })
        }
    }

    const htmlTip = useMemo(() => {
        let html = '<ul>';
        for(let i=0;i<hierarchy.length;++i) {
            const plan = hierarchy[i];
            const texts = text.filter((e) => e.planId === plan.planId && e.text);
            if ( texts.length > 0 ) {
                html += `<li><b>${plan.title}</b></li>`;
                html += '<ul>';
                for(let k=0;k<texts.length;++k) {
                    html += `<li>${texts[k].text}</li>`;
                }
                html += '</ul>';
            }
        }
        html += "</ul>";
        console.log("htmlTip:", html );
        return html;
    }, [text] );

    return (
        <>
            <HtmlTooltip title={text && <pre className={classes.pre} dangerouslySetInnerHTML={{ __html: htmlTip }} />}>
                <IconButton onClick={(e) => setEditText(true)}><InfoOutlined /></IconButton>
            </HtmlTooltip>
            <Dialog
                maxWidth="md"
                fullWidth={true}
                open={editText}
                onClose={() => onClose()}
                PaperComponent={PaperComponent} //need this to drag
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle className={classes.dialog} id="draggable-dialog-title">
                    <div className={classes.closeButton}>
                        <Button onClick={() => onClose()}>Close</Button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {hierarchy.map((plan) => {
                        const note = text.find((e) => e.planId === plan.planId) || { planId: plan.planId, category: 'rosetta', textId, language, text: '' };
                        return <div>
                            <Typography variant='subtitle1'>{plan.title}</Typography>
                            <TextField
                                style={{ width: '95%'}}
                                multiline
                                variant="outlined"
                                className={classes.note}
                                minRows={1}
                                value={note.text}
                                label="Note"
                                onChange={(e) => {
                                    const otherText = text.filter((k) => k.planId !== plan.planId);
                                    setText([ ...otherText, { ...note, text: e.target.value } ]);
                                    setModified(true);
                                }} />
                        </div>
                    })}
                </DialogContent>
            </Dialog>
        </>
    );
}

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}


const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#fcfcfc',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 620,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const styles = {
    pre: {
        whiteSpace: 'pre-wrap',
    },
    closeButton: {
        position: 'absolute',
        margin: "2px",
        padding: "0px",
        width: "90px",
        height: "50px",
        fontSize: '1rem',
        right: 0,
        top: 8,
    },
    dialog: {
        cursor: 'move'
    },
    note: {
        margin: "5px",
        border: '1px',
    }
}

export default withStyles(styles)(EditableNote)

